import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MiscellaneousServices = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.02 13.97 1.7-2.94s-.09-.08-.23-.18l-1.47-1.16-.01.02c.03-.24.05-.47.05-.71s-.02-.47-.06-.69l.01.01 1.71-1.34-1.7-2.95-2.01.81v.01c-.37-.28-.77-.52-1.2-.7h.01L10.52 2H7.11L6.8 4.15h.01c-.43.18-.83.42-1.2.7v-.01L3.6 4.03 1.9 6.98l1.7 1.34.01-.01c-.03.22-.05.45-.05.69s.02.47.05.71l-.01-.02-1.47 1.16c-.13.1-.23.18-.23.18l1.7 2.94 2.02-.8-.02-.03c.37.29.77.53 1.21.71H6.8L7.11 16h3.4s.02-.13.04-.3l.27-1.85h-.01c.44-.18.84-.42 1.21-.71l-.02.03 2.02.8zM8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm12.17 6.94-.01.01c.02-.15.03-.3.03-.45 0-.15-.01-.3-.04-.44l.01.01 1.1-.86-1.09-1.9-1.29.52v.01c-.24-.18-.49-.33-.77-.45h.01l-.2-1.39h-2.19l-.2 1.38h.01c-.28.12-.53.27-.77.45v-.01l-1.29-.52-1.09 1.9 1.09.86.01-.01c-.02.14-.03.29-.03.44 0 .15.01.3.03.46l-.01-.01-.94.75c-.08.06-.15.12-.15.12l1.09 1.89 1.3-.51-.01-.02c.24.19.5.34.78.46h-.01l.2 1.38h2.19s.01-.08.03-.19l.17-1.19h-.01c.28-.12.54-.27.78-.46l-.01.02 1.3.51 1.09-1.89s-.06-.05-.15-.12l-.96-.75zm-3.35.85c-.71 0-1.29-.58-1.29-1.29s.58-1.29 1.29-1.29 1.29.58 1.29 1.29-.58 1.29-1.29 1.29z"
  }));
});
MiscellaneousServices.displayName = 'MiscellaneousServices';
export var MiscellaneousServicesDimensions = {
  height: 24,
  width: 24
};